import { GetterTree } from 'vuex';
import { FinancialInstitutionState, FinancialInstitution } from './types';
import { RootState } from '../types';

export const getters: GetterTree<FinancialInstitutionState, RootState> = {
    fiCompany(state): FinancialInstitution {
        const { financialInstitution } = state;
        return financialInstitution;
    },

    fiId(state): number | undefined {
        const { financialInstitution } = state;
        return financialInstitution.kasasaFiConfigId;
    },
};